angular.module('shared-components', [
  'shared-components.extended-filters',
]);
